import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=4df07fe2&scoped=true&"
import script from "./NoResults.vue?vue&type=script&lang=js&"
export * from "./NoResults.vue?vue&type=script&lang=js&"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=4df07fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df07fe2",
  null
  
)

export default component.exports